import React from "react";
import { Button, Space, Card, Typography } from "antd";
import { FilterOutlined, ClearOutlined } from "@ant-design/icons";

const { Text } = Typography;

export function SelectFiltros(props) {
  const {
    estados = [],
    destinos = [],
    setFiltroEstados,
    setFiltroDestinos,
    filtroestados = [],
    filtrodestinos = []
  } = props;

  // Toggle para destinos
  const toggleDestino = (destino) => {
    const isSelected = filtrodestinos.includes(destino);
    let newDestinos;
    
    if (isSelected) {
      newDestinos = filtrodestinos.filter(d => d !== destino);
    } else {
      newDestinos = [...filtrodestinos, destino];
    }
    
    console.log("Nuevos destinos seleccionados:", newDestinos);
    setFiltroDestinos(newDestinos);
  };

  // Toggle para estados
  const toggleEstado = (estado) => {
    const isSelected = filtroestados.includes(estado);
    let newEstados;
    
    if (isSelected) {
      newEstados = filtroestados.filter(e => e !== estado);
    } else {
      newEstados = [...filtroestados, estado];
    }
    
    console.log("Nuevos estados seleccionados:", newEstados);
    setFiltroEstados(newEstados);
  };

  // Limpiar todos los filtros
  const clearAllFilters = () => {
    console.log("Limpiando todos los filtros");
    setFiltroDestinos([]);
    setFiltroEstados([]);
  };

  // Limpiar destinos
  const clearDestinos = () => {
    console.log("Limpiando destinos");
    setFiltroDestinos([]);
  };

  // Limpiar estados
  const clearEstados = () => {
    console.log("Limpiando estados");
    setFiltroEstados([]);
  };

  return (
    <Card 
      size="small" 
      style={{ marginBottom: 16 }}
      title={
        <Space>
          <FilterOutlined />
          <Text strong>Filtros</Text>
          {(filtrodestinos.length > 0 || filtroestados.length > 0) && (
            <Text type="secondary" style={{ fontSize: '12px' }}>
              ({filtrodestinos.length + filtroestados.length} activos)
            </Text>
          )}
        </Space>
      }
      extra={
        <Space>
          <Button 
            type="text" 
            size="small"
            onClick={clearDestinos}
            disabled={filtrodestinos.length === 0}
          >
            Limpiar destinos
          </Button>
          <Button 
            type="text" 
            size="small"
            onClick={clearEstados}
            disabled={filtroestados.length === 0}
          >
            Limpiar estados
          </Button>
          <Button 
            type="text" 
            icon={<ClearOutlined />} 
            onClick={clearAllFilters}
            size="small"
            disabled={filtrodestinos.length === 0 && filtroestados.length === 0}
          >
            Limpiar todo
          </Button>
        </Space>
      }
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        {/* Filtro de Destinos */}
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <Text strong>
              Destinos {destinos.length > 0 && `(${filtrodestinos.length}/${destinos.length})`}
            </Text>
            {filtrodestinos.length > 0 && (
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {filtrodestinos.join(', ')}
              </Text>
            )}
          </div>
          <Space wrap size={[6, 6]}>
            {destinos.map((destino) => {
              const isSelected = filtrodestinos.includes(destino.descripcion);
              return (
                <Button
                  key={destino.descripcion}
                  type={isSelected ? "primary" : "default"}
                  size="small"
                  onClick={() => toggleDestino(destino.descripcion)}
                  style={{ 
                    borderRadius: '16px',
                    fontSize: '12px',
                    fontWeight: isSelected ? '600' : '400',
                    borderColor: isSelected ? '#1890ff' : '#d9d9d9',
                    backgroundColor: isSelected ? '#1890ff' : '#fff'
                  }}
                >
                  {destino.descripcion}
                </Button>
              );
            })}
          </Space>
        </div>

        {/* Filtro de Estados */}
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <Text strong>
              Estados {estados.length > 0 && `(${filtroestados.length}/${estados.length})`}
            </Text>
            {filtroestados.length > 0 && (
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {filtroestados.join(', ')}
              </Text>
            )}
          </div>
          <Space wrap size={[6, 6]}>
            {estados.map((estado) => {
              const isSelected = filtroestados.includes(estado.descripcion);
              return (
                <Button
                  key={estado.descripcion}
                  type={isSelected ? "primary" : "default"}
                  size="small"
                  onClick={() => toggleEstado(estado.descripcion)}
                  style={{ 
                    borderRadius: '16px',
                    fontSize: '12px',
                    fontWeight: isSelected ? '600' : '400',
                    borderColor: isSelected ? '#1890ff' : '#d9d9d9',
                    backgroundColor: isSelected ? '#1890ff' : '#fff'
                  }}
                >
                  {estado.descripcion}
                </Button>
              );
            })}
          </Space>
        </div>
      </Space>
    </Card>
  );
}